/**
 * The asset store's own limits, as the server enforces them.
 *
 * The number lives here ONCE and the dialog derives both its hint text and its
 * refusal from it. A second, smaller number typed into the frontend would be a
 * claim that only holds while somebody keeps the two in step — and the way it
 * breaks is silent: the user is told one limit and the upload fails against
 * another.
 *
 * Mirrored rather than compared: the two run in separate containers and cannot
 * read each other's source, so each side pins the same literal in its own test.
 * Server side: `AssetUploadAction::MAX_SIZE_BYTES` and its allowed-type list.
 */
export const MAX_ASSET_UPLOAD_BYTES = 20 * 1024 * 1024;

/** The same limit in the unit the hint text shows, derived rather than typed. */
export const MAX_ASSET_UPLOAD_MIB = MAX_ASSET_UPLOAD_BYTES / (1024 * 1024);

/**
 * The types the endpoint accepts, measured there from the bytes rather than
 * believed from the declaration. SVG is deliberately absent: the browser
 * EXECUTES it. Refusing it client-side is not the security control — the server
 * is — but without it an SVG pick would turn into an unexplained mid-save
 * failure instead of an immediate, named refusal.
 */
export const ALLOWED_IMAGE_MIME_TYPES: readonly string[] = [
    'image/png',
    'image/jpeg',
    'image/webp',
    'image/gif',
];
